<template>
  <div class="device-list-container">
    <!-- 页面标题 -->
    <!-- <div class="page-header">
      <h2>系统管理</h2>
      <p>管理所有物联网系统及相关信息</p>
    </div> -->

    <el-card class="main-card">
      <div slot="header" class="card-header">
        <div class="header-actions">
          <span class="card-title">mqtt订阅列表</span>
          <el-button type="primary" icon="el-icon-plus" @click="handleAddDevice" class="add-btn">
            添加mqtt订阅
          </el-button>
        </div>
      </div>

      <!-- 搜索区域 -->
      <div class="filter-bar">
        设备编号：<el-input placeholder="请输入设备编号" style="margin-right: 20px;" v-model="searchKeyword"
          prefix-icon="el-icon-search" class="search-input" @input="handleSearch"></el-input>
        <!-- 系统ID：<el-input placeholder="请输入系统编码" v-model="searchKeywordCode" prefix-icon="el-icon-search"
                    class="search-input" @input="handleSearch"></el-input> -->
      </div>

      <!-- 系统表格 -->
      <el-table :data="devices" border class="device-table" stripe highlight-current-row
        :row-class-name="tableRowClassName">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="ID"></el-table-column>
        <!-- <el-table-column prop="code" label="系统编码" width="230"></el-table-column> -->
        <el-table-column prop="serverId" label="服务器id"></el-table-column>
        <el-table-column prop="topics" label="订阅主题"></el-table-column>
        <el-table-column prop="equipmentCode" label="所属设备编号"></el-table-column>
        <el-table-column prop="status" label="订阅状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" style="color: #ff4d4f;">未订阅</span>
            <span v-if="scope.row.status == 1" style="color: #52c41a;">已订阅</span>
          </template>
        </el-table-column>

        <el-table-column prop="enabled" label="是否启用">
          <template slot-scope="scope">
            <span v-if="scope.row.enabled == 0" style="color: #ff4d4f;">禁用</span>
            <span v-if="scope.row.enabled == 1" style="color: #52c41a;">启用</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="240">
          <template slot-scope="scope">

            <el-button size="mini" type="text" @click="handleEditDevice(scope.row)" class="operation-btn edit-btn">
              编辑
            </el-button>
            <el-button size="mini" type="text" @click="handleDeleteDevice(scope.row.id)"
              class="operation-btn delete-btn">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" class="pagination"></el-pagination>
      </div>
    </el-card>

    <!-- 新增mqtt订阅弹窗 -->
    <el-dialog title="新增mqtt订阅信息" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false"
      :destroy-on-close="true" custom-class="custom-dialog">
      <el-form ref="deviceFormSys" :model="deviceFormSys" :rules="rules" label-width="120px" class="device-form">
        <!-- mqtt -->

        <el-form-item label="服务器id" prop="id">
          <!-- <el-input v-model="deviceFormTemplate.templateCode" placeholder="请输入模板编码" show-word-limit
            class="form-input"></el-input> -->
          <el-select v-model="deviceFormSys.id" placeholder="请选择服务器id" clearable class="form-select">
            <el-option v-for="item in portInfoArr" :key="item.id" :label="item.templateName"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="订阅主题" prop="topics">
          <el-input v-model="deviceFormSys.topics" placeholder="订阅主题" maxlength="50" show-word-limit
            class="form-input"></el-input>
        </el-form-item>
        <el-form-item label="所属设备编号" prop="equipmentCode">
          <el-input v-model="deviceFormSys.equipmentCode" placeholder="所属设备编号" maxlength="50" show-word-limit
            class="form-input"></el-input>
        </el-form-item>

        <el-form-item label="是否启用" prop="enabled">
          <el-radio v-model="deviceFormSys.enabled" :label="0">禁用</el-radio>
          <el-radio v-model="deviceFormSys.enabled" :label="1">开启</el-radio>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" class="dialog-btn cancel-btn">取消</el-button>
        <el-button type="primary" @click="handleSave" class="dialog-btn confirm-btn">保存</el-button>
      </div>
    </el-dialog>



    <!-- 修改mqtt订阅弹窗 -->
    <el-dialog title="修改mqtt订阅信息" :visible.sync="dialogVisibleEdit" width="500px" :close-on-click-modal="false"
      :destroy-on-close="true" custom-class="custom-dialog">
      <el-form ref="deviceFormSysEdit" :model="deviceFormSysEdit" :rules="rules" label-width="120px"
        class="device-form">
        <!-- mqtt -->

        <el-form-item label="服务器id" prop="serverId">
          <!-- <el-input v-model="deviceFormTemplate.templateCode" placeholder="请输入模板编码" show-word-limit
            class="form-input"></el-input> -->
          <el-select v-model="deviceFormSysEdit.serverId" placeholder="请选择服务器id" clearable class="form-select">
            <el-option v-for="item in portInfoArr" :key="item.id" :label="item.templateName"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="订阅主题" prop="topics">
          <el-input v-model="deviceFormSysEdit.topics" placeholder="订阅主题" maxlength="50" show-word-limit
            class="form-input"></el-input>
        </el-form-item>
        <el-form-item label="所属设备编号" prop="equipmentCode">
          <el-input v-model="deviceFormSysEdit.equipmentCode" placeholder="所属设备编号" maxlength="50" show-word-limit
            class="form-input"></el-input>
        </el-form-item>
        
        <el-form-item label="是否启用" prop="enabled">
          <el-radio v-model="deviceFormSysEdit.enabled" :label="0">禁用</el-radio>
          <el-radio v-model="deviceFormSysEdit.enabled" :label="1">开启</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleEdit = false" class="dialog-btn cancel-btn">取消</el-button>
        <el-button type="primary" @click="handleSaveEdit" class="dialog-btn confirm-btn">保存</el-button>
      </div>
    </el-dialog>



  </div>
</template>

<script>
import { mqttList, serverList, mqttStatus, delmqtt } from '@/api/mqtt'
export default {
  name: 'DeviceList',
  data() {
    return {
      selectedIds: [], // 绑定“选中的传感器id”的数组
      counts: {}, // 存储“每个传感器对应的数量”的对象
      radio: '1',
      searchKeyword: '',
      deviceStatus: '',
      deviceType: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogVisibleEdit: false,
      searchKeywordCode: "",
      deviceequipmentTypes: [],
      // 系统表单数据
      deviceForm: {
        name: '',
        code: '',
        type: ''
      },
      deviceFormSysEdit: {
        serverId: "",
        topics: '',
        equipmentCode: '',
        enabled: 1
      },
      deviceFormSys: {
        serverId: "",
        topics: "",
        equipmentCode: "",
        enabled: 1
      },
      devices: [],
      // 系统类型选项 
      deviceTypes: [],
      // 表单验证规则
      rules: {
        id: [
          { required: true, message: '请输入服务器id', trigger: 'blur' },
        ],
        topics: [
          { required: true, message: '请输入订阅主题', trigger: 'blur' },
        ],
        equipmentCode: [
          { required: true, message: '请输入所属设备编号', trigger: 'blur' },
        ],
       
      },
      rulestytem: {
        id: [
          { required: true, message: '请输入服务器id', trigger: 'blur' },
        ],
        topics: [
          { required: true, message: '请输入订阅主题', trigger: 'blur' },
        ],
        equipmentCode: [
          { required: true, message: '请输入所属设备编号', trigger: 'blur' },
        ], 
     
      },
      portInfoArr: []
    }
  },
  watch: {
    // 监听选中id的变化，初始化/清理数量
    selectedIds(newVal, oldVal) {
      // 新增选中项：初始化数量为1（确保响应式，用$set）
      newVal.forEach(id => {
        if (!this.counts[id]) {
          this.$set(this.counts, id, 1);
        }
      });
      // 取消选中项：删除对应数量（可选，若需保留可注释）
      oldVal.forEach(id => {
        if (!newVal.includes(id)) {
          this.$delete(this.counts, id);
        }
      });
    }
  },
  computed: {
    // 过滤系统列表 - 优化搜索逻辑
    filteredDevices() {
      // 如果没有搜索关键词，直接返回所有系统
      if (!this.searchKeyword) {
        return [...this.devices];
      }
      const keyword = this.searchKeyword.toLowerCase();
      return this.devices.filter(device => {
        // 确保系统名称和编码存在，避免undefined错误
        const nameMatch = device.name
          ? device.name.toLowerCase().includes(keyword)
          : false;
        const codeMatch = device.code
          ? device.id.toLowerCase().includes(keyword)
          : false;
        return nameMatch || codeMatch;
      })
    },
    // 分页处理
    pagedDevices() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.filteredDevices.slice(startIndex, endIndex);
    }
  },
  mounted() {
    this.systemInfo();
    // this.categoryList(); // 提前加载系统类型
  },
  methods: {
    // 为表格行添加交替样式
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'table-row-even' : 'table-row-odd';
    },


    generateSubmitData() {
      // 遍历选中的ID，映射成后端需要的格式
      this.equipmentTemplateSensorList = this.selectedIds.map((sensorTypeId, index) => {
        return {
          sensorTypeId: Number(sensorTypeId), // 传感器ID
          sensorNum: Number(this.counts[sensorTypeId]), // 对应的数量
          sort: index + 1
        };
      });
    },



    //删除系统
    handleDeleteDevice(id) {
      this.$confirm('确定要删除该mqtt主题吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await delmqtt(id)
        if (res.code == "0000") {
          this.$message.success('mqtt主题删除成功')
          this.systemInfo()
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },



    //新增mqtt订阅保存
    async handleSave() {
      let list = {
        serverId: this.deviceFormSys.id,
        qos: 1,
        topics: this.deviceFormSys.topics,
        equipmentCode: this.deviceFormSys.equipmentCode,
        enabled: this.deviceFormSys.enabled,
      }
      const res = await mqttStatus(list)
      if (res.code == "0000") {
        this.$message.success('mqtt主题订阅成功')
        this.systemInfo()
        this.dialogVisible = false;
      } else {
        this.$message.error(res.message)
      }
    },


    //保存编辑的信息
    async handleSaveEdit() {
      let list = {
        id: this.deviceFormSysEdit.id,
        qos: 1,
        serverId: this.deviceFormSysEdit.serverId,
        topics: this.deviceFormSysEdit.topics,
        equipmentCode: this.deviceFormSysEdit.equipmentCode,
        enabled: this.deviceFormSysEdit.enabled,
      }
      // console.log("list",list)
      const res = await mqttStatus(list)
      if (res.code == "0000") {
        this.$message.success('mqtt主题订阅成功')
        this.systemInfo()
        this.dialogVisibleEdit = false;
      } else {
        this.$message.error(res.message)
      }
    },




    handleEditDialogClose() {
      this.selectedIds = [];  // 清空传感器选中状态
      this.counts = {};       // 清空传感器数量
      this.radio = "1";       // 重置启用状态为默认值
      // 重置表单（避免下次打开残留旧数据）
      if (this.$refs.deviceFormEdit) {
        this.$refs.deviceFormEdit.resetFields();
      }
    },


    //点击修改系统信息弹框
    async handleEditDevice(item) {
      // console.log("vitem", item)
      this.dialogVisibleEdit = false;
      this.deviceFormSysEdit.topics = item.topics
      this.deviceFormSysEdit.equipmentCode = item.equipmentCode
      this.deviceFormSysEdit.serverId = item.serverId
      this.deviceFormSysEdit.id = item.id
      this.deviceFormSysEdit.enabled = item.enabled
      await this.portInfo()
      this.dialogVisibleEdit = true;
    },


    //mqtt列表接口
    async systemInfo() {
      try {
        let list = {
          "filter": [
            {
              "name": "equipmentCode",
              "value": this.searchKeyword,
              "type": "LIKE"
            }
          ],
          current: this.currentPage,
          size: this.pageSize,
        }
        const res = await mqttList(list)
        this.devices = res.result.records || []; // 确保有默认空数组
        this.total = res.result.total;
      } catch (error) {
        console.error(error)
        this.devices = []; // 出错时重置为空数组
      }
    },




    // 搜索处理 - 重置页码并重新加载数据
    handleSearch() {
      this.currentPage = 1; // 搜索时重置到第一页
      this.systemInfo()
    },

    handleSizeChange(val) {
      this.pageSize = val;
      // this.currentPage = 1; // 当页面大小改变时，重置到第一页
      this.systemInfo()
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.systemInfo()
    },

    getTypeName(type) {
      const typeMap = {
        temperature: '温度传感器',
        humidity: '湿度传感器',
        switch: '智能开关',
        smoke: '烟雾报警器'
      }
      return typeMap[type] || '未知类型'
    },

    getTypeTagType(type) {
      const typeMap = {
        temperature: 'primary',
        humidity: 'success',
        switch: 'warning',
        smoke: 'info'
      }
      return typeMap[type] || 'default'
    },


    async portInfo() {
      try {
        let list = {
          current: 1,
          size: 999,
        }
        const res = await serverList(list)
        this.portInfoArr = res.result.records || []; // 确保有默认空数组
      } catch (error) {
        console.error(error)
        this.portInfoArr = []; // 出错时重置为空数组
      }
    },




    handleAddDevice() {
      this.deviceFormSys = { serverId: '', topics: '', equipmentCode: '', enabled: 1 }; // 重置表单
      this.portInfo()
      this.dialogVisible = true;
    },

    handleViewDetails(item) {
      this.$router.push({
        name: 'SensorList',
        query: {
          id: item.id,
          code: item.code,
          name: item.name
        }
      })
    },
  }
}
</script>

<style scoped>
.sensor-item {
  display: flex;
  align-items: center;
  gap: 12px;
  /* Checkbox与数量控件的间距 */
  margin-bottom: 8px;
  /* 上下项间距 */
}

/* 调整数量控件宽度 */
.count-input {
  width: 120px;
}

/* 全局样式 */
.device-list-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

/* 页面标题 */
.page-header {
  margin-bottom: 24px;
}

.page-header h2 {
  font-size: 22px;
  color: #1f2937;
  margin-bottom: 8px;
  font-weight: 600;
}

.page-header p {
  font-size: 14px;
  color: #6b7280;
}

/* 主卡片样式 */
.main-card {
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: none;
  overflow: hidden;
  transition: all 0.3s ease;
}

.main-card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}


.header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

.add-btn {
  transition: all 0.2s ease;
}

.add-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
}

/* 搜索区域 */
.filter-bar {
  display: flex;
  margin: 20px;
  align-items: center;
}

.search-input {
  width: 300px;
  height: 40px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.search-input:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1);
}

/* 表格样式 */
.device-table {
  margin: 0 20px;
  border-radius: 6px;
  overflow: hidden;
}

::v-deep .el-table th {
  background-color: #f7f8fa;
  font-weight: 500;
  color: #4b5563;
  padding: 12px 0;
}

::v-deep .el-table td {
  padding: 12px 0;
}

.table-row-even {
  background-color: #fff;
}

.table-row-odd {
  background-color: #fafafa;
}

::v-deep .el-table__row:hover>td {
  background-color: #f0f7ff !important;
}

::v-deep .el-table__current-row>td {
  background-color: #e6f7ff !important;
}

/* 操作按钮样式 */
.operation-btn {
  padding: 4px 8px;
  margin: 0 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.view-btn {
  color: #1890ff;
}

.view-btn:hover {
  background-color: rgba(24, 144, 255, 0.1);
}

.edit-btn {
  color: #52c41a;
}

.edit-btn:hover {
  background-color: rgba(82, 196, 26, 0.1);
}

.delete-btn {
  color: #ff4d4f;
}

.delete-btn:hover {
  background-color: rgba(255, 77, 79, 0.1);
}

/* 分页样式 */
.pagination-container {
  margin: 20px;
  padding-top: 15px;
  border-top: 1px solid #f0f2f5;
  text-align: right;
}

::v-deep .el-pagination {
  font-size: 14px;
}

::v-deep .el-pagination button,
::v-deep .el-pagination span:not([class*='suffix']) {
  height: 32px;
  line-height: 32px;
  min-width: 32px;
  border-radius: 4px;
}

::v-deep .el-pagination .el-pager li {
  margin: 0 3px;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  line-height: 32px;
}

::v-deep .el-pagination .el-pager li.active {
  background-color: #1890ff;
  color: #fff;
}

/* 表单样式 */
.device-form {
  margin-top: 15px;
}

.form-input,
.form-select {
  width: 100%;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.form-input:focus,
.form-select:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1);
}

/* 弹窗样式 */
::v-deep .custom-dialog {
  border-radius: 12px;
  overflow: hidden;
}

::v-deep .custom-dialog .el-dialog__header {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f2f5;
  background-color: #f7f8fa;
}

::v-deep .custom-dialog .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

::v-deep .custom-dialog .el-dialog__body {
  padding: 20px;
}

::v-deep .custom-dialog .el-dialog__footer {
  padding: 12px 20px;
  border-top: 1px solid #f0f2f5;
}

.sonser-box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

::v-deep .el-checkbox__label {
  padding-left: 6px !important;
}

::v-deep .el-checkbox {
  padding-right: 10px;
}

/* 弹窗按钮 */
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.dialog-btn {
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.cancel-btn {
  background-color: #f5f5f5;
  color: #4b5563;
  border-color: #e0e0e0;
}

.cancel-btn:hover {
  background-color: #e9e9e9;
  color: #374151;
}

.confirm-btn {
  background-color: #1890ff;
  border-color: #1890ff;
}

.confirm-btn:hover {
  background-color: #0f7ae5;
  border-color: #0f7ae5;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
}

/* 优化表单项间距 */
::v-deep .el-form-item {
  margin-bottom: 20px;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .device-list-container {
    padding: 10px;
  }

  .search-input {
    width: 100%;
  }

  .header-actions {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .pagination-container {
    text-align: center;
  }

  ::v-deep .el-table {
    font-size: 13px;
  }

  ::v-deep .el-table .el-table__cell {
    padding: 8px 0;
  }

  .operation-btn {
    padding: 2px 6px;
    font-size: 12px;
  }
}
</style>
